import Home from "../pages/Home.vue";
import Users from "../pages/Users.vue";
import User from "../pages/User.vue";
import Roles from "../pages/Roles.vue";
import Permissions from "../pages/Permissions.vue";
import Login from "../pages/Login.vue";
import Employees from "../pages/Employees.vue";
import Employee from "../pages/Employee.vue";
import EmployeesReport from "../pages/EmployeesReport.vue";
import EmployeeUpdate from "../pages/EmployeeUpdate.vue";
import Departments from "../pages/Departments.vue";
import Assets from "../pages/Assets.vue";
import Asset from "../pages/Asset.vue";
import AssetTypes from "../pages/AssetTypes.vue";
import AssetUpdate from "../pages/AssetUpdate.vue";
import Meetings from "../pages/Meetings.vue";
import MeetingEvents from "../pages/MeetingEvents.vue";
import Contracts from "../pages/Contracts.vue";
import Contract from "../pages/Contract.vue";
import ContractUpdate from "../pages/ContractUpdate.vue";
import Customers from "../pages/Customers.vue";
import Tasks from "../pages/Tasks.vue";
import Task from "../pages/Task.vue";
import TaskView from "../pages/TaskView.vue";
import TaskUpdate from "../pages/TaskUpdate.vue";
import TaskAll from "../pages/TaskAll.vue";
import TasksAssignedTo from "../pages/TasksAssignedTo.vue";
import LeaveSchedule from "../pages/LeaveSchedule.vue";
import LeaveScheduleReport from "../pages/LeaveScheduleReport.vue";
import Rooms from "../pages/Rooms.vue";
import AssetsReport from "../pages/AssetsReport.vue";
import PicklistMenu from "../pages/PicklistMenu.vue";
import Projects from "../pages/Projects.vue";
import ProjectUpdate from "../pages/ProjectUpdate.vue";
import ChangePassword from "../pages/changePassword.vue";
import ResetPassword from "../pages/ResetPassword.vue";
import ContractsReport from "../pages/ContractsReport.vue";
import Dashboard from "../pages/Dashboard.vue";
import Salaries from "../pages/Salaries.vue";
import SalariesPayroll from "../pages/SalariesPayroll.vue";
import SalariesGeneralPayroll from "../pages/SalariesGeneralPayroll.vue";
import SalariesSIPayroll from "../pages/SalariesSIPayroll.vue";
import SalariesHistory from "../pages/SalariesHistory.vue";
import SalariesReport from "../pages/SalariesReport.vue";
import Banks from "../pages/Banks.vue";
import Qtakes from "../pages/Qtakes.vue";
import QtakeDepartments from "../pages/QtakeDepartments.vue";
import QtakeProjects from "../pages/QtakeProjects.vue";
import QtakeCosts from "../pages/QtakeCosts.vue";
import QtakeReport from "../pages/QtakeReport.vue";
import QtakeDepartmentPrices from "../pages/QtakeDepartmentPrices.vue";
import ContractCalendar from "../pages/ContractCalendar.vue";
// import ThuTucs from "../pages/ThuTucs.vue";

//#region Master Schedule: Update 06/01/2022 add production booking by tandn
import Productions from "../pages/Productions.vue";
//#endregion

//#region Time-Off Register: Update 13/06/2023 Create Module by tandn
import TimeOffRequest from "../pages/TimeOffRequest.vue";
import TimeOffHistory from "../pages/TimeOffHistory.vue";
import TimeOffManagement from "../pages/TimeOffManagement.vue";
import ConfirmApproval from "../pages/ConfirmApproval.vue";
//#endregion

/*Pitch Update*/
import p_User from "../pages/pitch/p_Users.vue";
import p_Group from "../pages/pitch/p_Group.vue";
import p_Permission from "../pages/pitch/p_Permission.vue";
import p_PicklistMenu from "../pages/pitch/p_PicklistMenu.vue";
import p_PitchSales from "../pages/pitch/p_PitchSale.vue";
import value from "../pages/Value.vue";

//TEST PAGE
import Test from "../pages/_Test.vue";
// ***
// Ptiching đạo diễn
import pitching from "../pages/pitching/pitching_main.vue";
import Director_Group from "../pages/pitching/Director_Group.vue";
import Director_kind from "../pages/pitching/Director_kind.vue";
import Director_Permission from "../pages/pitching/Director_Permission.vue";
import Director_RateValue from "../pages/pitching/Director_RateValue.vue";
//Incentives
import bonus_Rate1 from "../pages/Bonus/Bonus_Rate1.vue";
import bonus_group from "../pages/Bonus/Bonus_Group.vue";
import bonus_position from "../pages/Bonus/Bonus_Position.vue";
import bonus_Grouptemplate from "../pages/Bonus/Bonus_GroupTemplate.vue";
import bonus_Sales from "../pages/Bonus/Bonus_Sales.vue";
import bonus_Post from "../pages/Bonus/Bonus_Post.vue";
import bonus_Permission from "../pages/Bonus/Bonus_permission.vue";
import Bonus_blankPage from "../pages/Bonus/Bonus_blankPage.vue";
import Bonus_Note from "../pages/Bonus/Bonus_Note.vue";

const routes = [
  { path: "/bonus_Note", component: Bonus_Note },
  { path: "/Bonus_blankPage", component: Bonus_blankPage },
  { path: "/bonus_Permission", component: bonus_Permission },
  { path: "/bonus_Post", component: bonus_Post },
  { path: "/bonus_Sales", component: bonus_Sales },
  { path: "/bonus_Grouptemplate", component: bonus_Grouptemplate },
  { path: "/bonus_position/:type", component: bonus_position },
  { path: "/bonus_position2/:type", component: bonus_position },
  { path: "/bonus_group", component: bonus_group },
  { path: "/bonus_Rate1", component: bonus_Rate1 },
  { path: "/director_Permission", component: Director_Permission },
  { path: "/director_kind", component: Director_kind },
  { path: "/director_Group", component: Director_Group },
  { path: "/pitching", component: pitching },
  { path: "/director_ratevalue", component: Director_RateValue },
  { path: "/value", component: value },
  { path: "/p_PitchSales", component: p_PitchSales },
  { path: "/p_PicklistMenu", component: p_PicklistMenu },
  { path: "/p_Permission", component: p_Permission },
  { path: "/p_Group", component: p_Group },
  { path: "/p_Users", component: p_User },
  { path: "/homepage", component: Home },
  { path: "/dashboard", component: Dashboard },
  { path: "/account", component: Users },
  { path: "/account/:slug", component: User },
  { path: "/add_account", component: User },
  { path: "/user_group", component: Roles },
  { path: "/permission", component: Permissions },
  { path: "/login", component: Login, meta: { noAuth: true } },
  { path: "/hr_record", name: "hr_record", component: Employees },
  { path: "/add_hr_record", name: "add_hr_record", component: Employee },
  {
    path: "/hr_record/:slug",
    name: "edit_hr_record",
    component: EmployeeUpdate,
  },
  { path: "/employee_report", component: EmployeesReport },
  { path: "/employee_report/:id", component: EmployeesReport },
  { path: "/department", component: Departments },
  { path: "/asset", name: "asset", component: Assets },
  { path: "/add_asset", name: "add_asset", component: Asset },
  { path: "/edit_asset/:slug", name: "edit_asset", component: AssetUpdate },
  { path: "/asset_type", name: "asset_type", component: AssetTypes },
  { path: "/asset_report", name: "asset_report", component: AssetsReport },
  { path: "/asset_room", name: "asset_room", component: Rooms },
  { path: "/booking_managerment", component: Meetings },
  { path: "/booking", component: MeetingEvents },
  { path: "/booking_contract", component: ContractCalendar },
  { path: "/customer", component: Customers },
  { path: "/contract", component: Contracts },
  { path: "/add_contract", component: Contract },
  { path: "/contract/:id", component: ContractUpdate },
  { path: "/contract_report", component: ContractsReport },
  { path: "/cong_viec", component: Tasks },
  { path: "/tat_ca_cong_viec", component: TaskAll },
  { path: "/cong_viec_da_giao", component: TasksAssignedTo },
  { path: "/them_cong_viec", component: Task },
  { path: "/cong_viec/:id", component: TaskView },
  { path: "/picklist", component: PicklistMenu },
  { path: "/sua_cong_viec/:id", component: TaskUpdate },
  { path: "/project", component: Projects },
  { path: "/project/:id", component: ProjectUpdate },
  { path: "/lich_nghi_phep", component: LeaveSchedule },
  { path: "/bao_cao_lich_nghi_phep", component: LeaveScheduleReport },
  { path: "/change_password/:id", component: ChangePassword },
  { path: "/reset_password/:id", component: ResetPassword },
  { path: "/tinh_luong", component: Salaries },
  { path: "/bang_luong", component: SalariesPayroll },
  { path: "/bang_luong_tong_hop", component: SalariesGeneralPayroll },
  { path: "/bang_luong_BHXN", component: SalariesSIPayroll },
  { path: "/lich_su_thay_doi_luong", component: SalariesHistory },
  { path: "/thong_ke_luong_phu_cap", component: SalariesReport },
  { path: "/bank", component: Banks },
  { path: "/qtake_booking", component: Qtakes },
  { path: "/qtake_project", component: QtakeProjects },
  { path: "/qtake_department", component: QtakeDepartments },
  { path: "/qtake_cost", component: QtakeCosts },
  { path: "/qtake_report", component: QtakeReport },
  { path: "/qtake_price", component: QtakeDepartmentPrices },
  //#region update 6/1/2022 add production booking
  { path: "/production_booking", component: Productions },
  { path: "/time_off_request/:slug/create", component: TimeOffRequest },
  { path: "/time_off_request/:slug", component: TimeOffHistory },
  { path: "/time_off_management", component: TimeOffManagement },
  {
    path: "/confirm_approval/:id/:line_manager_id/:confirm",
    component: ConfirmApproval,
    meta: { noAuth: true },
  },
  // #endregion
  { path: "*", redirect: "/homepage" },
  // { path: "/he_thong", component: Users, meta: { permission: "hethong_view" } },
  // { path: "/nguoi_dung/:slug", component: User, meta: { permission: "hethong_view" } },
  // { path: "/them_nguoi_dung", component: User, meta: { permission: "hethong_view" } },
  // { path: "/nhom_nguoi_dung", component: Roles, meta: { p ermission: "hethong_view" } },
  // { path: "/quyen", component: Permissions, meta: { permission: "hethong_view" } },
  // { path: "/thu_tuc", component: ThuTucs },
];

export default routes;
